exports.components = {
  "component---src-pages-dashboard-js": () => import("./../../../src/pages/dashboard.js" /* webpackChunkName: "component---src-pages-dashboard-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-the-complete-guideto-tire-care-jsx": () => import("./../../../src/pages/TheCompleteGuidetoTireCare.jsx" /* webpackChunkName: "component---src-pages-the-complete-guideto-tire-care-jsx" */)
}

